import {
  buildCategoryIcon,
  DEFAULT_MENU_CATEGORIES,
} from "../menu/defaultMenuConfig";

const STORAGE_PREFIX = "mozzoapp:menu";

const createLocalId = (prefix) =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const createDefaultSnapshot = () => {
  const categories = DEFAULT_MENU_CATEGORIES.map((category) => ({
    id: createLocalId("categoria"),
    nombre: category.name,
    icon: category.icon || buildCategoryIcon(category.name),
  }));

  const subcategoriasPorCategoria = categories.reduce((acc, category, index) => {
    const defaults = DEFAULT_MENU_CATEGORIES[index]?.subcategories || [];
    acc[category.id] = defaults.map((name) => ({
      id: createLocalId("subcategoria"),
      nombre: name,
    }));
    return acc;
  }, {});

  return {
    menuId: "local-menu",
    categories,
    subcategoriasPorCategoria,
    linkedSubcategoryRules: [],
    products: [],
  };
};

const getStorageKey = (branchId) => `${STORAGE_PREFIX}:${branchId || "default"}`;

export const loadLocalMenuCategories = (branchId, { includeSubcategories = false } = {}) => {
  try {
    const snapshot = JSON.parse(window.localStorage.getItem(getStorageKey(branchId)) || "null");
    const categories = Array.isArray(snapshot?.categories) ? snapshot.categories : [];
    return includeSubcategories ? categories.map((category) => ({ ...category,
      subcategories: Array.isArray(snapshot.subcategoriasPorCategoria?.[category.id])
        ? snapshot.subcategoriasPorCategoria[category.id] : [],
    })) : categories;
  } catch {
    return [];
  }
};

export const toLightMenuSnapshot = (snapshot) => ({
  ...snapshot,
  categories: (snapshot.categories || []).map((category) => ({ ...category, imageUrl: "", fotoUrl: "" })),
  products: (snapshot.products || []).map((product) => {
    const ingredients = (product.ingredientes || product.ingredients || []).map((ingredient) => ({
      ...ingredient, imageUrl: "", fotoUrl: "", imagen: "",
    }));
    return {
      ...product, foto: null, fotoUrl: null, imageUrl: null,
      imageDeferred: true, imageMenuId: snapshot.menuId,
      ingredients, ingredientes: ingredients,
    };
  }),
});
export const loadLocalMenuSnapshot = (branchId) => {
  if (typeof window === "undefined") {
    return createDefaultSnapshot();
  }

  try {
    const raw = window.localStorage.getItem(getStorageKey(branchId));
    if (!raw) {
      return createDefaultSnapshot();
    }

    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.categories)) {
      return createDefaultSnapshot();
    }

    return {
      mode: parsed.mode || "shared",
      menuId: parsed.menuId || "local-menu",
      categories: parsed.categories || [],
      subcategoriasPorCategoria: parsed.subcategoriasPorCategoria || {},
      linkedSubcategoryRules: parsed.linkedSubcategoryRules || [],
      products: parsed.products || [],
    };
  } catch (error) {
    console.error("No pudimos leer el menu local:", error);
    return createDefaultSnapshot();
  }
};

export const saveLocalMenuSnapshot = (branchId, snapshot) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(
      getStorageKey(branchId),
      JSON.stringify({
        mode: snapshot.mode || "shared",
        menuId: snapshot.menuId || "local-menu",
        categories: snapshot.categories || [],
        subcategoriasPorCategoria: snapshot.subcategoriasPorCategoria || {},
        linkedSubcategoryRules: snapshot.linkedSubcategoryRules || [],
        products: snapshot.products || [],
      })
    );
  } catch (error) {
    console.error("No pudimos guardar el menu local:", error);
  }
};
